const links = document.querySelectorAll('.forms nav a')
const tabs = document.querySelectorAll('.forms .tabs .tab')
const mql = window.matchMedia('(min-width: 1200px)')

for (const el of links) {
    el.addEventListener('click', (e) => {
        const link = e.target
        const tab = document.querySelector(
            `.forms .tabs [data-slug="${link
                .getAttribute('href')
                .substring(1)}"]`
        )
        for (const link of links) {
            link.classList.remove('active')
        }
        link.classList.add('active')
        for (const tab of tabs) {
            tab.classList.remove('active')
        }
        if (tab) {
            tab.classList.add('active')
        }
    })
}

if (document.body.classList.contains('t-contact')) {
    const mqlHandler = () => {
        let link, hash

        // detect hash
        if (document.location.hash.startsWith('#')) {
            hash = document.location.hash.substring(1)
            link = document.querySelector(`.forms a[href="#${hash}"]`) || null

            // if desktop, can't be first link
            if (mql.matches && link === links[0]) {
                link = links[1] || null
            }
        }

        // no hash, or not valid
        if (!link) {
            link = mql.matches ? links[1] || null : links[0] || null
        }

        link.click()
    }

    mql.addEventListener('change', mqlHandler)

    mqlHandler()
}
